export const TARGET_ID = "cronofy-slot-picker";
